<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已审核</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">商品调拨单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate?documentItem.businessDate.replace(' 00:00:00', ''):''}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
				<Col span="8">单据编号：{{documentItem.code}}</Col>
				<Col span="8">业务日期：{{documentItem.businessDate?documentItem.businessDate.replace(' 00:00:00', ''):''}}</Col>
				<Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
				<Col span="8">入库仓库：{{documentItem.warehousing}}</Col>
				<Col span="8">制单日期：{{documentItem.createDate?documentItem.createDate.replace(' 00:00:00', ''):''}}</Col>
				<Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					商品信息
				</div>
			</div>
			<Table :columns="commodityColumn" :data="documentItem.commodityAllocationDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
		<div class="list-module" style="display: flex;justify-content: flex-end;">
			<button class="jxyd-button jxyd-primary" title="打印单据" @click="printDocument()">
				<Icon type="md-print" size='18' />
				打印
			</button>
			<button class="jxyd-button jxyd-primary" title="复制单据" @click="copyDocument(documentItem)">
				<Icon type="md-print" size='18' />
				复制
			</button>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	export default {
		name: 'commodityallocationlistdetail',
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					outbound: '',
					outboundName: '',
					warehousing: '',
					commodityAllocationDetailList: [],
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				depotTree: [],
				commodityColumn: [{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 300,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 100
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										disabled: !params.row.commodity.enableBatch,
										multiple: true,
										transfer: true,
										value: params.row.batchCode
									},
									on: {
										input: (event) => {}
									},
								},
								this.formatBatchCodeSelectData(params.index,params.row.unit).map(function(type) {
									return h('Option', {
										props: {
											value: type.value,
											key: type.text
										}
									}, type.text);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 200,
					},
					{
						title: '出库仓库',
						key: 'outboundName',
						width: 200
					},
					{
						title: '单价',
						key: 'price',
						width: 130
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					}
				]
			}
		},

		methods: {
			// getTransferDepot 函数 (通用函数)
			async getTransferDepot(param) {
			    try {
			        console.log('getTransferDepot 参数:', param);
			        
			        let splitResult = param.split(',');
			        if (splitResult.length !== 2) {
			            console.warn('仓库参数格式不正确:', param);
			            return param; // 返回原值而不是空字符串
			        }
			        
			        const result = await request.get('api/Depot/GetTransferDepot');
			        if (result.state !== 1) {
			            console.error('获取调拨仓库失败:', result.errorMsg);
			            return param; // 返回原值
			        }
			        const workshop = result.data.find(m => m.value == splitResult[0]);
			        if (!workshop) {
			            console.warn('未找到车间:', splitResult[0]);
			            return param;
			        }
			        
			        // 修正拼写错误：chlidren -> children
			        const depot = workshop.children.find(m => m.value == param);
			        if (!depot) {
			            console.warn('未找到仓库:', splitResult[1]);
			            return param;
			        }
			        return `${workshop.text},${depot.text}`;
			    } catch (error) {
			        console.error('getTransferDepot 执行失败:', error);
			        return param; // 错误时返回原值
			    }
			},
			async getCommodityAllocationData(params) {
			    try {
			        const isById = params.id !== undefined;
			        console.log(`开始获取调拨单数据，${isById ? 'ID:' : 'Code:'}`, isById ? params.id : params.code);
			        
			        const endpoint = isById 
			            ? '/api/CommodityAllocationList/GetCommodityAllocationList'
			            : '/api/CommodityAllocationList/GetCommodityAllocationByCode';
			        
			        const response = await request.get(endpoint, { params });
			        
			        if (response.state === 0) {
			            this.$Notice.error({
			                title: '错误提示',
			                duration: 3,
			                desc: response.errorMsg
			            });
			            return null;
			        }
			        
			        this.documentItem = response.data;
			        console.log('获取的数据:', this.documentItem);
			        
			        // 处理 warehousing
			        if (this.documentItem.warehousing) {
			            console.log('开始转换仓库信息:', this.documentItem.warehousing);
			            this.documentItem.warehousing = await this.getTransferDepot(this.documentItem.warehousing);
			            console.log('转换后的仓库信息:', this.documentItem.warehousing);
			        }
			        
			        return this.documentItem;
			    } catch (error) {
			        console.error('获取调拨单数据失败:', error);
			        this.$Notice.error({
			            title: '错误提示',
			            duration: 3,
			            desc: '网络请求失败，请稍后重试'
			        });
			        return null;
			    }
			},
			async copyDocument(param) {
				let self = this;
				await this.$Modal.confirm({
					title: "操作警告",
					content: "是否复制单据？",
					async onOk() {
						let result = await request.get('api/CommodityAllocationList/GetNextCode', {
							params: {
								prefix: 'DBD'
							}
						});
						if (!result || result.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '获取编号失败'
							});
							return;
						}
						let data = JSON.parse(JSON.stringify(param));
						data.id = 0;
						data.code = result.data;
						data.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
						data.createDate = data.businessDate;
						data.userId = parseInt(localStorage.getItem("userId"));
						data.userName = localStorage.getItem("userName");
						data.creator = parseInt(localStorage.getItem("userId"));
						data.checkState = 1;
						self.dataSubmitAndCheck(data);
					},
					onCancel() {}
				});
			},
			dataSubmitAndCheck(data) {
				let self = this
				request.post('api/CommodityAllocationList/EditCommodityAllocationList', data).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败'
						});
						return
					}
					//记录商品调拨单操作
					let log = {
						FlowId: result.data,
						Title: '商品调拨单日志',
						OperationContent: '创建了此商品调拨单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					};
					request.post('api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败'
							});
							return;
						}
					}).catch(err => {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '日志记录失败'
						});
					})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '复制成功'
					});
				}).catch(err => {})
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.commodityAllocationDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.commodityAllocationDetailList[index]
						.format &&
						commodityInventorys[i].depotId == this.documentItem.commodityAllocationDetailList[index].outbound
						) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.commodityAllocationDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.commodityAllocationDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getUnitData(item,unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			formatBatchCodeSelectData(index,unit) {
				let data = this.documentItem.commodityAllocationDetailList[index];
				let unitData = this.getUnitData(data,unit);
				if (data && unitData) {
					let list = []
					if (data.commodity.commodityInventorys) {
						let array = data.commodity.commodityInventorys.filter(m => m.stock > 0 && m
							.commodityPriceType == data.format && m.depotId == data.outbound);
						array = array.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
						for (let i = 0; i < array.length; i++) {
							list.push({
								value: array[i].batchCode,
								text: `${array[i].batchCode}(${formatNum(array[i].stock*unitData.conversionRate)}${unit})`
							})
						}
					}
					return list;
				}
				return [];
			},
			printDocument() {
				this.packPrintData([this.documentItem]);
			},
			packPrintData(data) {
				for(let i = 0; i < data.length;i++){
					switch (data[i].checkState) {
						case 1:
							data[i].checkState = '已创建'
							break;
						case 2:
							data[i].checkState = '已审核'
							break;
						case 3:
							data[i].checkState = '已完结'
							break;
					}
					data[i].businessDate = data[i].businessDate.replace(' 00:00:00', '');
				}
				let selectedReceiptData = {
					name: 'commodityAllocationList',
					title: '商品调拨单',
					attributes: ['baseFieldItem', 'commodityAllocationDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'warehousing',
							displayName: '入库仓库'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					commodityAllocationDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						// {
						// 	name: 'batchCode',
						// 	displayName: '商品批次'
						// },
						{
							name: 'outboundName',
							displayName: '出库仓库'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						},
						{
							name: 'quantity',
							displayName: '数量'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
		},
		watch: {
		    '$route.query.allocationListId': {
		        immediate: true,
		        async handler(param) {
		            if (param) {
		                await this.getCommodityAllocationData({ id: param });
		            }
		        }
		    },
		    '$route.query.allocationListCode': {
		        immediate: true,
		        async handler(param) {
		            if (param) {
		                await this.getCommodityAllocationData({ code: param });
		            }
		        }
		    }
		},
		created: function() {}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.list-base {
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}

	.list-base-left {
		float: left;
		display: flex;
		color: #000;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 100%;
		/* 父元素需要固定高度或其它百分比高度 */
	}

	.list-base-left-span {
		font-size: 18px;
	}

	.list-base-right {
		display: flex;
		float: right;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 36px;
	}

	.list-base-right-span {
		margin-left: 10px;
	}

	.span-back-color {
		color: #000;
	}

	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.list-module {
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}

	.div-content-row div {
		padding: 15px;
	}

	.div-content-row-center div {
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}

	.amount-color {
		color: rgb(255, 106, 127);
	}

	.div-content-detail {
		margin: 15px;
		background-color: #f8f8f9;
		padding: 20px;
	}

	.div-content-detail-title {
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}

	.div-content-detail-list {
		margin-top: 10px;
	}

	.div-content-detail-list-title {
		text-indent: 0.5em;
	}

	.div-content-detail-list-content {
		overflow: hidden;
	}

	.div-content-detail-list-content-item {
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
</style>